import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Spin } from "antd"
import { useListInvitationsQuery } from "../../invitation/invitationApi"

const columns= [
  {
    key: "email",
    title: "Email",
    dataIndex: "email",
  },
  {
    key: "created_at",
    dataIndex: "created_at",
    title: "Created At",
    render: (val) => new Date(val).toDateString(),
  },
];

export default function InvitationListView() {
  const { data, isLoading } = useListInvitationsQuery(0);
  if (isLoading) return <><div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", height: "90vh" }}>
    <Spin tip="Loading..." />
  </div></>
  return (
    <>
      <Table columns={columns} dataSource={data || []} size="large" pagination={false}/>
    </>
  );
}
